import { Condition, RestaurantTunnelData } from '../../models';
import http, { HttpSuccessOrErrorType, ListResults, OkPacket } from '../http';

const api = {
    /**
     * 获取deliverect平台日志数据
     * @param params 参数
     */
    async get_deliverect_log(params: any & Condition): Promise<HttpSuccessOrErrorType<ListResults<RestaurantTunnelData>[]>> {
        return await http.get(`/deliverect/log`, {
            params: {
                ...params
            }
        })
    },

    /**
     * 删除一个deliverect订单
     * @param _id 
     * @returns 
     */
    async delete_deliverect_order_id(_id: string): Promise<HttpSuccessOrErrorType<OkPacket>> {
        return await http.delete(`/deliverect_order/${_id}`)
    }

}
export default api